export default {
  darkest: "#C9283E",
  dark: "#FF9E41",
  normal: "#5BC0BE",
  normalWithAlpha: "#5BC0BE55",
  light: "#EF2D56",
  lightest: "#1E272C",
  backgroundTop: "#010D17",
  backgroundBottom: "#011627",
  shadow: "#b95d6f1a",
  key: "Dark Theme"
};



// WEBPACK FOOTER //
// ./src/utils/theme.dark.js